// Parent route for /squad/battle/$id/* — pass-through; children own UI.
import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/squad/battle/$id')({
  component: () => <Outlet />,
})
